import { createBrowserHistory } from 'history';
import { routerMiddleware, routerReducer } from 'react-router-redux';
import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import { reducers as fdiDashboardReducers } from '../Dashboard';
import epic from '../epic';
import { reducers as statesReducers } from '../states';

// redux
const reduxCombineReducers: any = combineReducers; //tslint:disable-line
import { createEpicMiddleware } from 'redux-observable';
const reducer = reduxCombineReducers({
  router: routerReducer,
  stateDetailState: statesReducers.stateDetailReducer,
  fdiDashboardState: fdiDashboardReducers.reducer,
});

class RWindow extends Window {
  __REDUX_DEVTOOLS_EXTENSION_COMPOSE__!: typeof compose;
}

const rwindow = window as RWindow;
const composeEnhancers = rwindow.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const epicMiddleware = createEpicMiddleware();
const history = createBrowserHistory();

const store = createStore(
  reducer,
  composeEnhancers(
    applyMiddleware(epicMiddleware, routerMiddleware(history)),
  )
);

epicMiddleware.run(epic);

export * from './state';
export {
  store,
  history
};



// WEBPACK FOOTER //
// ./src/store/index.ts